'use client';

import { useCallback } from 'react';
import { useAuctions } from '../../queries/useAuctionQueries';
import type { ActiveAuctionsResponse } from '../../services/api';
import type { AuctionStatusFilter } from './types';

interface UseAuctionsDataResult {
  auctions: ActiveAuctionsResponse['auctions'];
  loading: boolean;
  error: string;
  isInitialLoad: boolean;
  loadAuctions: () => void;
}

export const useAuctionsData = (filter: AuctionStatusFilter): UseAuctionsDataResult => {
  const {
    data: auctions,
    isLoading,
    error: queryError,
    refetch,
  } = useAuctions(filter);

  const error = queryError
    ? queryError instanceof Error
      ? queryError.message
      : 'Failed to load auctions'
    : '';

  // Memoize loadAuctions to prevent infinite loops in useAuctionTimer
  const loadAuctions = useCallback(() => {
    refetch();
  }, [refetch]);

  return {
    auctions: auctions || [],
    loading: isLoading,
    error,
    isInitialLoad: isLoading && !auctions,
    loadAuctions,
  };
};
